<script lang="ts" generics="T extends string">
  import InvalidHoverInfo from '@components/InvalidHoverInfo.svelte'
  import InvalidIcon from '@components/InvalidIcon.svelte'
  import ReadOnly from '@components/ReadOnly.svelte'
  import { requiredFieldValidator, type ValidityState } from '@utils/validation.svelte'

  interface Props {
    id: string
    label: string
    invalids: Record<T, ValidityState>
    field: T
    value?: string
    readOnly?: boolean
    inputClass?: string
    name?: string
    placeholder?: string
  }

  let {
    id,
    label,
    invalids,
    field,
    value = $bindable(),
    readOnly = false,
    inputClass = 'autocomplete my-0 box-border flex px-2 py-1 md:min-w-96',
    name,
    placeholder,
  }: Props = $props()
</script>

<label for={id}>{label}</label>
{#if readOnly}
  <ReadOnly {value} />
{:else}
  <div class="input-group input-group-divider grid-cols-[1fr_auto]">
    <input
      class="{inputClass} {invalids[field].invalid ? 'input-error [&&]:text-black' : ''}"
      type="text"
      {id}
      {name}
      oninvalid={requiredFieldValidator(invalids[field])}
      onchange={requiredFieldValidator(invalids[field])}
      bind:value
      required
      {placeholder}
    />
    <InvalidIcon {invalids} {field} {value}></InvalidIcon>
  </div>
  <InvalidHoverInfo {invalids} {field}></InvalidHoverInfo>
{/if}
